export default __webpack_public_path__ + "static/media/duplicate.e7b70c81.svg";